var _style, _desc, _g, _defs, _mask, _polygon, _defs2, _mask2, _polygon2, _defs3, _mask3, _polygon3, _defs4, _mask4, _polygon4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChuyenkhoanBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1440 1386",
    style: {
      enableBackground: "new 0 0 1440 1386"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#304465;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{opacity:0.4;mask:url(#mask-2_1_);fill:url(#Shape_1_);enable-background:new    ;}\n\t.st4{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st5{opacity:0.3;mask:url(#mask-2_2_);fill:url(#Shape-Copy-2_1_);enable-background:new    ;}\n\t.st6{filter:url(#Adobe_OpacityMaskFilter_2_);}\n\t.st7{mask:url(#mask-2_3_);fill:url(#Shape-Copy-9_1_);}\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_3_);}\n\t.st9{mask:url(#mask-2_4_);fill:url(#Shape-Copy-10_1_);}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#shadow_1_);}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Trusted all ove the world") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "Design"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trusted-all-ove-the-world"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CTA"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1440,
    height: 1386
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 1068,
    y: -74,
    width: 688,
    height: 1108.2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1068,
    y: -74,
    width: 688,
    height: 1108.2,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1_1_",
    className: "st2",
    width: 1440,
    height: 1386
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -238.0337,
    y1: 1093.2678,
    x2: -238.2119,
    y2: 1092.5132,
    gradientTransform: "matrix(688 0 0 -1108.1752 165261 1211454.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#574AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#574AE2",
      stopOpacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#574AE2",
      stopOpacity: 0.24
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#574AE2",
      stopOpacity: 0.1
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    className: "st3",
    points: "1284.4,1034.2 1068,1034.2 1539.6,-74 1756,-74  "
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: -587.2,
    y: -199,
    width: 972.2,
    height: 1566
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -587.2,
    y: -199,
    width: 972.2,
    height: 1566,
    id: "mask-2_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1_2_",
    className: "st2",
    width: 1440,
    height: 1386
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape-Copy-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -238.1353,
    y1: 1093.1906,
    x2: -238.3135,
    y2: 1092.4358,
    gradientTransform: "matrix(972.2362 0 0 -1566 231538.2188 1711732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5842DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#5842DE",
      stopOpacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#5842DE",
      stopOpacity: 0.24
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#574AE2",
      stopOpacity: 0.1
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-Copy-2",
    className: "st5",
    points: "-281.4,1367 -587.2,1367 79.2,-199 385,-199  "
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 1031,
    y: 520,
    width: 688,
    height: 1113.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1031,
    y: 520,
    width: 688,
    height: 1113.3,
    id: "mask-2_3_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1_3_",
    className: "st2",
    width: 1440,
    height: 1386
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape-Copy-9_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -238.7861,
    y1: 1092.4988,
    x2: -238.965,
    y2: 1091.734,
    gradientTransform: "matrix(-688 0 0 1113.2836 -162952 -1214892.625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#37517E",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#37517E",
      stopOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#37517E",
      stopOpacity: 0.97
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#37517E"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-Copy-9",
    className: "st7",
    points: "1502.6,520 1719,520 1247.4,1633.3 1031,1633.3  "
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    filterUnits: "userSpaceOnUse",
    x: -39,
    y: -253,
    width: 651,
    height: 1053.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -39,
    y: -253,
    width: 651,
    height: 1053.4,
    id: "mask-2_4_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1_4_",
    className: "st2",
    width: 1440,
    height: 1386
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape-Copy-10_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -238.8058,
    y1: 1092.4838,
    x2: -238.9848,
    y2: 1091.719,
    gradientTransform: "matrix(-651 0 0 1053.4122 -155216 -1150286.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#37517E",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#37517E",
      stopOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#37517E",
      stopOpacity: 0.97
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#37517E"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-Copy-10",
    className: "st9",
    points: "407.2,-253 612,-253 165.8,800.4 -39,800.4  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shadow_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -238.2924,
    y1: 1098.0905,
    x2: -238.2924,
    y2: 1097.3564,
    gradientTransform: "matrix(1151 0 0 -55 274995 61629)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F4468",
      stopOpacity: 0.07314312
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4468"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "shadow",
    x: 145,
    y: 1232,
    className: "st10",
    width: 1151,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChuyenkhoanBg);
export default __webpack_public_path__ + "static/media/chuyenkhoan_bg.e90f39f268064560bd750ad0656a8d0d.svg";
export { ForwardRef as ReactComponent };